import template from "./template.html.twig";
import "./style.scss";

const { Component } = Shopware;

Component.register("neti-ior-cart-sidebar-filter", {
    template,

    inject: [
        "acl"
    ],

    data() {
        return {
            filterCount: 0,
            filter: {
                firstName: "",
                lastName: "",
                value: { from: null, to: null },
                createdAt: { from: null, to: null },
                mailed: -1
            },
            mailedOptions: [
                {
                    value: -1,
                    label: this.$t('neti-incomplete-order-reminder.list.sidebar-filter.mailed.none')
                },
                {
                    value: true,
                    label: this.$t('neti-incomplete-order-reminder.list.sidebar-filter.mailed.true')
                },
                {
                    value: false,
                    label: this.$t('neti-incomplete-order-reminder.list.sidebar-filter.mailed.false')
                }
            ],
        };
    },

    methods: {
        onResetFilters() {
            this.filter = {
                firstName: "",
                lastName: "",
                value: { from: null, to: null },
                createdAt: { from: null, to: null },
                mailed: -1
            };

            this.onUpdateFilters();
        },

        onUpdateFilters() {
            const filters = this.collectFilters();

            this.$emit("change", filters);
            this.filterCount = Object.keys(filters).length;
        },

        collectFilters() {
            const filters = {};

            if (this.filter.firstName !== "") {
                filters.firstName = this.filter.firstName;
            }

            if (this.filter.lastName !== "") {
                filters.lastName = this.filter.lastName;
            }

            if (this.filter.value.from !== null) {
                filters.valueFrom = this.filter.value.from;
            }

            if (this.filter.value.to !== null) {
                filters.valueTo = this.filter.value.to;
            }

            if (parseInt(this.filter.mailed) !== -1) {
                filters.mailed = this.filter.mailed;
            }

            if (this.filter.createdAt.to !== null) {
                filters.createdTo = this.filter.createdAt.to;
            }

            if (this.filter.createdAt.from !== null) {
                filters.createdFrom = this.filter.createdAt.from;
            }

            return filters;
        },
    }
});
